import script from "./CardNameTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardNameTitle.vue?vue&type=script&setup=true&lang=ts"

import "./CardNameTitle.vue?vue&type=style&index=0&id=4a6a1892&lang=scss&scoped=true"
script.__scopeId = "data-v-4a6a1892"

export default script